import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {ProtectedRoute} from '../auth/require-authorization';
import {ActionCodeListing} from './action-code-listing';
import {ActionCodeCreate, ActionCodeUpdate} from './action-code-create-update';

export const ActionCodeRoutes: RouteObject = {
  path: ROUTES.ADMIN.ACTION_CODES.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.ACTION_CODES.INDEX.path,
      element: <ActionCodeListing />,
    },
    {
      path: ROUTES.ADMIN.ACTION_CODES.CREATE.path,
      element: <ActionCodeCreate />,
    },
    {
      path: ROUTES.ADMIN.ACTION_CODES.DETAIL.path,
      element: <ActionCodeUpdate />,
    },
  ],
};
